<template>
  <ul :class="`${className || ''} c-list-technos`">
    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.typescript
      }}</span>
      <IconTs />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.javascript
      }}</span>
      <IconJs />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.vue
      }}</span>
      <IconVue />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.nuxt
      }}</span>
      <IconNuxt />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.sass
      }}</span>
      <IconSass />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.strapi
      }}</span>
      <IconStrapi />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.wordpress
      }}</span>
      <IconWp />
    </li>

    <li class="c-list-technos__item">
      <span class="c-list-technos__tooltip t-t2 t-powder">{{
        technos.woo
      }}</span>
      <IconWoo />
    </li>
  </ul>
</template>

<script>
import IconJs from "./icones/js.vue";
import IconNuxt from "./icones/nuxt.vue";
import IconSass from "./icones/sass.vue";
import IconStrapi from "./icones/strapi.vue";
import IconTs from "./icones/ts.vue";
import IconVue from "./icones/vue.vue";
import IconWoo from "./icones/woo.vue";
import IconWp from "./icones/wp.vue";

export default {
  name: "ListTechnos",
  components: {
    IconJs,
    IconNuxt,
    IconSass,
    IconStrapi,
    IconTs,
    IconVue,
    IconWoo,
    IconWp,
  },
  props: {
    technos: Object,
    className: String,
  },
};
</script>

<style lang="sass">
.c-list-technos
  +size(100%, auto)
  margin-bottom: 10rem
  display: flex
  justify-content: space-between

  +break-max($tablet)
    margin-bottom: 5rem

  &__item
    position: relative
    +size(100% / 9, 0)
    padding-bottom: calc(100% / 9)
    border-radius: 100%
    overflow: hidden

    &:after
      content: ''
      border: solid 5px $black
      border-radius: 100%
      +absolute(0, 0)
      +size(calc(100% - 10px))

      +break-max($tablet)
        border-width: 2px
        +size(calc(100% - 4px))

    &:hover
      +break-min($tablet)
        .c-list-technos__tooltip
          opacity: 1

  &__tooltip
    +absolute(0, 0)
    +size(100%)
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    padding: 10px
    background-color: $black
    z-index: 1
    opacity: 0
    +transition-25-ease

    &::selection
      background-color: $powder
      color: $black

    +break-max($tablet)
      bottom: -10px
      color: $black

  &__image
    +absolute(0, 0)
    +size(100%)
</style>
